import ELK from 'elkjs';

// https://www.eclipse.org/elk/reference/algorithms/org-eclipse-elk-layered.html
const layoutOptions = {
    'elk.algorithm': 'layered',
    'elk.direction': 'RIGHT',
    'elk.layered.spacing.edgeNodeBetweenLayers': '40',
    'elk.spacing.nodeNode': '40',
    'elk.layered.nodePlacement.strategy': 'BRANDES_KOEPF',
};

const nodePorts = {
    workflowStartNode: { src: ['output'], tgt: [] },
    endNode: { src: [], tgt: ['input'] },
    doNode: { src: ['output'], tgt: ['input'] },
    waitNode: { src: ['output'], tgt: ['input'] },
    decideNode: { src: ['yes', 'no'], tgt: ['input'] },
    checklistNode: { src: ['output'], tgt: ['input'] }
}

export default getLayoutedNodes = async (nodes, edges, placement) => {
    const elk = new ELK();
    console.log('ELK', edges, placement)

    layoutOptions['elk.layered.nodePlacement.strategy'] = placement || 'SIMPLE'
    const graph = {
        id: 'root',
        layoutOptions,
        children: nodes.map(n => {
            const targetPorts = nodePorts[n.type].tgt.map(t => ({
                id: n.id + '-' + t,
                // ⚠️ it's important to let elk know on which side the port is
                // in this example targets are on the left (WEST) and sources on the right (EAST)
                properties: {
                    side: 'WEST',
                },
            }));

            const sourcePorts = nodePorts[n.type].src.map(s => ({
                id: n.id + '-' + s,
                properties: {
                    side: 'EAST',
                },
            }));

            return {
                id: n.id,
                width: (n.width ?? 150) + 30 * Math.random(),
                height: n.height ?? 50,
                // ⚠️ we need to tell elk that the ports are fixed, in order to reduce edge crossings
                properties: {
                    'org.eclipse.elk.portConstraints': 'FIXED_ORDER',
                },
                // we are also passing the id, so we can also handle edges without a sourceHandle or targetHandle option
                ports: [{ id: n.id }, ...targetPorts, ...sourcePorts],
            };
        }),
        edges: edges.map((e) => ({
            id: e.id,
            sources: [e.source + '-' + e.sourceHandle],
            targets: [e.target + '-' + e.targetHandle],
        })),
    };
    // console.log('ELK', graph)

    const layoutedGraph = await elk.layout(graph);
    // console.log('ELK', layoutedGraph)

    const layoutedNodes = nodes.map(node => {
        const layoutedNode = layoutedGraph.children?.find(
            (lgNode) => lgNode.id === node.id,
        );

        return {
            ...node,
            position: {
                x: layoutedNode?.x ?? 0,
                y: layoutedNode?.y ?? 0,
            },
            positionAbsolute: {
                x: layoutedNode?.x ?? 0,
                y: layoutedNode?.y ?? 0,
            },
        };
    });

    // console.log('ELK', layoutedNodes)
    return layoutedNodes;
};
